import Vue from "vue";
import getBaseUrl from "../config/baseUrl";

Vue.prototype.$home = new Vue({
  methods: {
    getData(language = "en", filters) {
      let lang = language;

      if (lang === "pt") {
        lang = "pt-br";
      }

      let url = `${getBaseUrl()}bilboards/${lang}`;

      if (filters?.office) {
        url += `?office=${filters.office}`;
      }

      return new Promise((resolve, reject) => {
        this.$http
          .get(url)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },
  },
});
